import React, { useMemo } from 'react';

export default function MiniSparkline({
  values,
  width = 200,
  height = 28,
  color = 'var(--theme-primary, #2451b8)',
  fillOpacity = 0.18,
  strokeWidth = 1.5,
  showFill = true,
  ariaLabel,
}) {
  const path = useMemo(() => {
    const nums = (values || []).map(Number).filter((v) => !Number.isNaN(v));
    if (nums.length < 2) return null;
    const min = Math.min(...nums);
    const max = Math.max(...nums);
    const span = max - min || 1;
    const stepX = nums.length === 1 ? width : width / (nums.length - 1);
    const pad = strokeWidth + 1;
    const innerH = height - pad * 2;
    const points = nums.map((v, i) => {
      const x = i * stepX;
      const y = pad + innerH - ((v - min) / span) * innerH;
      return [x, y];
    });
    const line = points.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)} ${y.toFixed(1)}`).join(' ');
    const area = `${line} L${width.toFixed(1)} ${height.toFixed(1)} L0 ${height.toFixed(1)} Z`;
    return { line, area };
  }, [values, width, height, strokeWidth]);

  if (!path) return null;
  return (
    <svg viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none"
         width="100%" height={height} role={ariaLabel ? 'img' : 'presentation'}
         aria-label={ariaLabel}>
      {showFill && <path d={path.area} fill={color} fillOpacity={fillOpacity} />}
      <path d={path.line} fill="none" stroke={color} strokeWidth={strokeWidth}
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
